import {Component, ElementRef, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {GoodDataUnion} from '@portbase/bezoekschip-service-typescriptmodels';
import {VisitContext} from '../../../visit-context';
import {StowageModelUnion} from '../../dangerous-goods.model';
import {dispatchChangeEvent} from "../../../../common/utils";
import {PortvisitUtils} from '../../../../refdata/portvisit-utils';

@Component({
    selector: 'app-edit-stowage',
    templateUrl: './edit-stowage.component.html',
    styleUrls: ['./edit-stowage.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditStowageComponent {

  context = VisitContext;
  refData = PortvisitUtils;

  @Input() stowage: StowageModelUnion;
  @Input() disableGoodEdit: boolean;
  @Input() toggleTankContainer;
  @Input() isContainerItem: boolean;
  @Input() isHoldAtArrival: boolean;
  @Output() goodDataChanged = new EventEmitter<GoodDataUnion>();

  constructor(private elementRef : ElementRef) {
  }

  toggleOption = (stowage) => {
    this.toggleTankContainer(stowage);
  };

  ngAfterViewInit(): void {
    dispatchChangeEvent(this.elementRef.nativeElement);
  }

  hasNoBerthVisits() : boolean {
    return !this.context.visit.visitDeclaration.portVisit.berthVisits ||
           this.context.visit.visitDeclaration.portVisit.berthVisits.length === 0;
  }

  get isRotterdam(): boolean {
    return this.context.visit.portOfCall.port.locationUnCode === "NLRTM";
  }

  get isAmsterdam(): boolean {
    return this.context.visit.portOfCall.port.locationUnCode === "NLAMS";
  }
}
